import { render, staticRenderFns } from "./ReviewCard2.vue?vue&type=template&id=7b61273f&scoped=true"
import script from "./ReviewCard2.vue?vue&type=script&lang=js"
export * from "./ReviewCard2.vue?vue&type=script&lang=js"
import style0 from "./ReviewCard2.vue?vue&type=style&index=0&id=7b61273f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61273f",
  null
  
)

export default component.exports